module.exports = __webpack_public_path__ + "static/media/lumbering11.3e6b30c3.jpg";